module.exports = __webpack_public_path__ + "img/pptx.0c24b4d7.svg";